// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"23":"298ecbc53807cb58a66c328bf6897d88","795":"8a4bbda9326d76392d6429ae4a33d608"}[chunkId] + ".js";
};